/* Love Bouquet — Theme scripts (mobile drawer) */
(function(){
  document.addEventListener('click', function(e){
    var openBtn = e.target.closest('[data-lb-drawer-open]');
    var closeBtn = e.target.closest('[data-lb-drawer-close]');
    if (openBtn) {
      e.preventDefault();
      document.body.classList.add('lb-drawer-open');
    } else if (closeBtn) {
      document.body.classList.remove('lb-drawer-open');
      if (!closeBtn.hasAttribute('href')) {
        e.preventDefault();
      }
    }
  });
  // Close drawer with Escape key
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape') document.body.classList.remove('lb-drawer-open');
  });
})();

(function () {

  function isArabicStorefront() {
    return (
      document.documentElement.lang.startsWith('ar') ||
      Shopify.locale === 'ar'
    );
  }

  // Stop script on non-Arabic storefronts
  if (!isArabicStorefront()) {
    return;
  }

  const translations = {
    "On Sale": "للبيع",
    "Bestseller": "الأكثر مبيعًا",
    "Quick View": "عرض سريع",
    "Sort by:": "الترتيب حسب:",
    "products": "منتجات",
    "Featured": "مميز",
    "Best Selling": "الأكثر مبيعا",
    "Newest": "الأحدث",
    "Price: Low to High": "السعر: من الأدنى إلى الأعلى",
    "Price: High to Low": "السعر: من الأعلى إلى الأدنى",
    "A — Z": "أ — ي",
    "Z — A": "ي — أ"
  };

  function translateText(text) {
    if (!text) return text;

    Object.keys(translations).forEach((key) => {
      if (text.includes(key)) {
        text = text.split(key).join(translations[key]);
      }
    });

    return text;
  }

  function walk(node) {
    if (node.nodeType === 3) {
      node.nodeValue = translateText(node.nodeValue);
    } else {
      node.childNodes.forEach(walk);
    }
  }

  function run() {
    walk(document.body);
  }

  document.addEventListener("DOMContentLoaded", run);

  const observer = new MutationObserver(() => {
    run();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();
